<template>
  <div class="popup-wrap">
    <div class="dimmed"/>
    <div class="popup-layer browser">
      <div class="popup-header">
        <button type="button" class="btn-close" @click="$emit('close', true)"><i class="ico-close"/></button>
      </div>
      <div
        class="popup-content">
        <h1>권장 브라우저 안내</h1>
        <div>
          <strong>원활한 사이트 이용을 위해<br>크롬 또는 엣지 브라우저를 이용해주세요.</strong>
          <span>본 사이트는 웹 표준을 준수하여 제작되었으며, IE 에서 일부 기능이 정상 작동하지 않을 수 있습니다.</span>
        </div>
        <ul class="browser-list">
          <li class="chrome"><button type="button" class="btn-type02" @click="fnBrowserLink('https://www.google.com/intl/ko/chrome', 'download')">바로가기</button></li>
          <li class="edge"><button type="button" class="btn-type02" @click="fnBrowserLink(linkUrl, targetNm)">바로가기</button></li>
        </ul>
        <div class="form-btn">
          <button type="button" class="btn-type03 btn-l" @click="$emit('close', true)"><span>닫기</span><i class="ico-arrow2" /></button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'WepBrowserModal',
  props: {
    linkUrl: {
      type: String,
      default: ''
    },
    targetNm: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
    }
  },
  computed: {
    commonAlertConfirmAttrs () {
      return {
        ...this.componentAttrs,
        useDefaultHeader: false,
        useDefaultFooter: false,
        fullModal: false,
        mainclass: {
          'alert_type': this.isAlert
        }
      }
    }
  },
  /* vue lifecycle */
  created () {
  },
  beforeMount () {
  },
  mounted () {
  },
  /* vue function */
  methods: {
    fnBrowserLink (linkUrl, targetNm) {
      if (targetNm === 'download') {
        window.open(linkUrl, targetNm)
      } else {
        window.location = 'microsoft-edge:' + linkUrl
        this.$emit('close', true)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/_common/wep-popup/WepBrowserModal.vue